const SELECTOR_FRAME  = '[data-component="field-mapping-frame"]';
const SELECTOR_SCROLL = '[data-component="field-mapping-scroll"]';
const SELECTOR_LEFT   = '[data-direction="left"]';
const SELECTOR_RIGHT  = '[data-direction="right"]';
const SELECTOR_HEADER = '.header-cell';

const watchedFrames = new WeakSet();

const findScroll = frame => frame.querySelector(SELECTOR_SCROLL);

const updateButtonVisibility = frame => {
    const scroll = findScroll(frame);

    if (!scroll) {
        return;
    }

    const leftButton  = frame.querySelector(SELECTOR_LEFT);
    const rightButton = frame.querySelector(SELECTOR_RIGHT);

    if (!leftButton || !rightButton) {
        return;
    }

    leftButton.toggleAttribute('hidden', scroll.scrollLeft <= 0);
    rightButton.toggleAttribute('hidden', scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 1);
};

const scrollPage = (scroll, direction) => {
    const amount = scroll.clientWidth * 0.85;

    scroll.scrollBy({
        left: direction === 'left' ? -amount : amount,
        behavior: 'smooth',
    });
};

/** @param {HTMLElement} button */
export const handleScrollButtonClick = button => {
    const frame  = button.closest(SELECTOR_FRAME);
    const scroll = frame ? findScroll(frame) : null;

    if (!scroll) {
        return;
    }

    scrollPage(scroll, button.dataset.direction);
};

const syncHeaderHeight = frame => {
    const header = frame.querySelector(SELECTOR_HEADER);

    if (!header) {
        return;
    }

    frame.style.setProperty('--field-mapping-header-height', `${header.offsetHeight}px`);
};

const attachWatcher = frame => {
    if (watchedFrames.has(frame)) {
        return;
    }

    const scroll = findScroll(frame);

    if (!scroll) {
        return;
    }

    watchedFrames.add(frame);
    scroll.addEventListener('scroll', () => updateButtonVisibility(frame));
    updateButtonVisibility(frame);
    syncHeaderHeight(frame);
};

/** @param {Document | Element} root */
export const attachScrollWatchers = (root = document) => {
    // root IS a frame (HTMX swapped the frame in directly)
    if (root.matches?.(SELECTOR_FRAME)) {
        attachWatcher(root);
    }

    // root CONTAINS frames somewhere inside it
    root.querySelectorAll?.(SELECTOR_FRAME).forEach(attachWatcher);
};

export const refreshFrameLayout = () => {
    document.querySelectorAll(SELECTOR_FRAME).forEach(frame => {
        updateButtonVisibility(frame);
        syncHeaderHeight(frame);
    });
};
